export default "__VITE_ASSET__DMFIBznA__"